/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

import thunk from './thunk';
import invariant from './invariant';
import createStore from './createStore';
import combineReducers from './combineReducers';
import bindActionCreators from './bindActionCreators';
import applyMiddleware from './applyMiddleware';
import compose from './compose';

export default {
    thunk,
    invariant,
    createStore,
    combineReducers,
    bindActionCreators,
    applyMiddleware,
    compose
}